import { DcddTotalUserProps } from "modules/report/dcdd_report/state/actionType";
import { MembershipCountProps, stateStatusType } from "./actionType";

export interface FetchCommercialTotalUserState {
    isLoading: boolean;
    error: string | null;
    commercialTotalUser: DcddTotalUserProps | null;
    status: stateStatusType | null;
}
export interface FetchCommercialTotalUserByFilterState {
    isLoading: boolean;
    error: string | null;
    commercialTotalUserByFilter: DcddTotalUserProps | null;
    status: stateStatusType | null;
}
export interface FetchMembershipCountState {
    isLoading: boolean;
    error: string | null;
    membershipCount: MembershipCountProps | null;
    status: stateStatusType | null;
}

export const initialCommercialTotalUsersState: FetchCommercialTotalUserState = {
    isLoading: false,
    error: null,
    commercialTotalUser: null,
    status: null,
};
export const initialCommercialTotalUsersByFilterState: FetchCommercialTotalUserByFilterState = {
    isLoading: false,
    error: null,
    commercialTotalUserByFilter: null,
    status: null,
};
export const initialMembershipCountState: FetchMembershipCountState = {
    isLoading: false,
    error: null,
    membershipCount: null,
    status: null,
};

export interface CommercialTotalUserState {
    commercialTotalUsersState: FetchCommercialTotalUserState;
    commercialTotalUserByFilterState:FetchCommercialTotalUserByFilterState
    membershipCountState:FetchMembershipCountState
}

export const initialState: CommercialTotalUserState = {
    commercialTotalUsersState: initialCommercialTotalUsersState,
    commercialTotalUserByFilterState: initialCommercialTotalUsersByFilterState,
    membershipCountState: initialMembershipCountState
};

